import { render, staticRenderFns } from "./PreferenceAccountTax.vue?vue&type=template&id=718c9c66&"
import script from "./PreferenceAccountTax.vue?vue&type=script&lang=ts&"
export * from "./PreferenceAccountTax.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('718c9c66')) {
      api.createRecord('718c9c66', component.options)
    } else {
      api.reload('718c9c66', component.options)
    }
    module.hot.accept("./PreferenceAccountTax.vue?vue&type=template&id=718c9c66&", function () {
      api.rerender('718c9c66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Preference/PreferenceAccountTax.vue"
export default component.exports